/**
 * Model Configuration for Fox River AI
 * This module provides configuration settings for LLM model parameters
 */

/**
 * Model configuration settings for different tasks
 */
export const modelConfig = {
  // Default model parameters
  default: {
    model: "claude-3-sonnet-20240229",
    temperature: 0.7,
    max_tokens: 1000,
    top_p: 0.9
  },
  
  // Parameters for project type detection (lower temperature for consistency)
  projectTypeDetection: {
    model: "claude-3-sonnet-20240229",
    temperature: 0.1,
    max_tokens: 100,
    top_p: 0.95
  },
  
  // Parameters for feature extraction (lower temperature for consistency)
  featureExtraction: {
    model: "claude-3-sonnet-20240229",
    temperature: 0.1,
    max_tokens: 300,
    top_p: 0.9
  },
  
  // Parameters for complexity classification (zero temperature for deterministic results)
  complexityClassification: {
    model: "claude-3-sonnet-20240229",
    temperature: 0.0,
    max_tokens: 50,
    top_p: 1.0
  },
  
  // Parameters for proposal generation (higher temperature for creativity)
  proposalGeneration: {
    model: "claude-3-sonnet-20240229",
    temperature: 0.7,
    max_tokens: 2000,
    top_p: 0.9
  }
};

/**
 * Get model parameters for a specific task
 * @param {String} task - Task name
 * @returns {Object} - Model parameters
 */
export const getModelParams = (task) => {
  switch (task) {
    case 'projectTypeDetection':
      return modelConfig.projectTypeDetection;
    case 'featureExtraction':
      return modelConfig.featureExtraction;
    case 'complexityClassification':
      return modelConfig.complexityClassification;
    case 'proposalGeneration':
      return modelConfig.proposalGeneration;
    default:
      return modelConfig.default;
  }
};